import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
// import parse from "html-react-parser";
// import { ContactlessOutlined, FlagSharp } from "@material-ui/icons";

class SettingItem extends Component {
  state = {
    selected: this.props.childProps.selected
      ? this.props.childProps.selected
      : false,
  };
  componentDidMount = () => {};
  _onChange = () => {
    const { gubun } = this.props.childProps;
    const { selected } = this.state;
    let flag;

    if (gubun === 'vod' || gubun === 'download') {
      if (!selected === true) {
        flag = '1080P';
      } else {
        flag = '720P';
      }
    } else {
      if (!selected === true) {
        flag = 'Y';
      } else {
        flag = 'N';
      }
    }

    if (gubun === 'autoskip') {
      this._changeAutoSkip(flag);
    } else if (gubun === 'autoplay') {
      this._changeAutoNext(flag);
    } else if (gubun === 'service') {
      this._changeServiceAlram(flag);
    } else if (gubun === 'event') {
      this._changeEventAlram(flag);
    } else if (gubun === 'reservation') {
      this._changeReservationAlram(flag);
    } else if (gubun === 'wishShare') {
      this._changeWishShare(flag);
    } else if (gubun === 'quickMenu') {
      this._changeQuickMenu(flag);
    } else if (gubun === 'vod') {
      this._changeBitRate(flag);
    } else if (gubun === 'download') {
      this._changeDownload(flag);
    }

    //this.setState({
    //    selected: !selected
    //})
  };
  _changeAutoSkip = async (flag) => {
    const { loginId, setAutoSkip } = this.props;
    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeAutoSkipApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          setAutoSkip(flag);
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeAutoSkipApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeAutoSkip1',
        {
          params: {
            userid: loginId,
            autoSkip: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _changeAutoNext = async (flag) => {
    const { loginId, setAutoNext } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeAutoNextApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          setAutoNext(flag);
          this.setState({
            selected: flag === 'Y' ? true : false,
          });

          const authCookies = this.getCookie('account');

          if (
            authCookies === null ||
            authCookies === undefined ||
            authCookies === ''
          ) {
          } else {
            if (authCookies) {
              const arrAuth = authCookies.split('&');
              //console.log(arrAuth)
              arrAuth.sort();
              //console.log(arrAuth)
              //let cookieData = 'messageCount_output=' + vod + '&birthDay=' + listData[0].birthDay + '&memberPartCode=' + listData[0].download + '&authId=' + authId + '&playerFlag=' + listData[0].playerFlag + '&couponCount=' + listData[0].autoNext + '&jumin=' + listData[0].jumin + '&point=' + listData[0].point + '&sex=' + listData[0].sex + '&loginName=' + listData[0].username + '&loginCode=' + listData[0].loginCode + '&loginId=' + userid

              arrAuth[2] = 'couponCount=' + flag;

              let cookieData =
                arrAuth[8] +
                '&' +
                arrAuth[1] +
                '&' +
                arrAuth[7] +
                '&' +
                arrAuth[0] +
                '&' +
                arrAuth[9] +
                '&' +
                arrAuth[2] +
                '&' +
                arrAuth[3] +
                '&' +
                arrAuth[10] +
                '&' +
                arrAuth[11] +
                '&' +
                arrAuth[6] +
                '&' +
                arrAuth[4] +
                '&' +
                arrAuth[5];
              this.setCookie('account', cookieData);
            }
          }
        }
      }
    }
  };
  _changeAutoNextApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeAutoNext1',
        {
          params: {
            userid: loginId,
            autoNext: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _changeServiceAlram = async (flag) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeServiceAlramApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeServiceAlramApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;

    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeServiceAlram',
        {
          params: {
            userid: loginId,
            serviceAlram: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _changeEventAlram = async (flag) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeEventAlramApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeEventAlramApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeEventAlram',
        {
          params: {
            userid: loginId,
            eventAlram: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _changeReservationAlram = async (flag) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeReservationAlramApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeReservationAlramApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeReservationAlram',
        {
          params: {
            userid: loginId,
            ReservationAlram: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _changeWishShare = async (flag) => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeWishShareApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeWishShareApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeWishShare',
        {
          params: {
            userid: loginId,
            wishShare: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _changeQuickMenu = async (flag) => {
    const { loginId, setQuickMenu } = this.props;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeQuickMenuApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          setQuickMenu(flag);
          this.setState({
            selected: flag === 'Y' ? true : false,
          });
        }
      }
    }
  };
  _changeQuickMenuApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    const { gubun } = this.props.childProps;

    return axios
      .post(
        apiUrl + '/changeQuickMenu',
        {
          params: {
            userid: loginId,
            quickMenu: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        // console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };

  _changeBitRate = async (flag) => {
    const { loginId, setBitrate } = this.props;
    const { _changeVod } = this.props.childProps;
    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeBitRateApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          setBitrate(flag);
          _changeVod(flag);
          this.setState({
            selected: flag === '1080P' ? true : false,
          });

          const authCookies = this.getCookie('account');
          if (
            authCookies === null ||
            authCookies === undefined ||
            authCookies === ''
          ) {
          } else {
            if (authCookies) {
              const arrAuth = authCookies.split('&');
              //console.log(arrAuth)
              arrAuth.sort();
              //console.log(arrAuth)
              //let cookieData = 'messageCount_output=' + vod + '&birthDay=' + listData[0].birthDay + '&memberPartCode=' + listData[0].download + '&authId=' + authId + '&playerFlag=' + listData[0].playerFlag + '&couponCount=' + listData[0].autoNext + '&jumin=' + listData[0].jumin + '&point=' + listData[0].point + '&sex=' + listData[0].sex + '&loginName=' + listData[0].username + '&loginCode=' + listData[0].loginCode + '&loginId=' + userid
              arrAuth[8] = 'messageCount_output=' + flag;

              let cookieData =
                arrAuth[8] +
                '&' +
                arrAuth[1] +
                '&' +
                arrAuth[7] +
                '&' +
                arrAuth[0] +
                '&' +
                arrAuth[9] +
                '&' +
                arrAuth[2] +
                '&' +
                arrAuth[3] +
                '&' +
                arrAuth[10] +
                '&' +
                arrAuth[11] +
                '&' +
                arrAuth[6] +
                '&' +
                arrAuth[4] +
                '&' +
                arrAuth[5];
              this.setCookie('account', cookieData);
            }
          }
        }
      }
    }
  };
  _changeBitRateApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;
    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/changeBitrate1',
        {
          params: {
            userid: loginId,
            bitrate: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async (gubun, flag) => {
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;

    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);

      if (gubun === 'autoskip') {
        this._changeAutoSkip(flag);
      } else if (gubun === 'autoplay') {
        this._changeAutoNext(flag);
      } else if (gubun === 'service') {
        this._changeServiceAlram(flag);
      } else if (gubun === 'event') {
        this._changeEventAlram(flag);
      } else if (gubun === 'reservation') {
        this._changeReservationAlram(flag);
      } else if (gubun === 'wishShare') {
        this._changeWishShare(flag);
      } else if (gubun === 'quickMenu') {
        this._changeQuickMenu(flag);
      } else if (gubun === 'vod') {
        this._changeBitRate(flag);
      } else if (gubun === 'download') {
        this._changeDownload(flag);
      }

      //this._getData()
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  _changeDownload = async (flag) => {
    const { loginId, setDownloadBitrate } = this.props;
    const { _changeDownload } = this.props.childProps;

    if (loginId === null || loginId === undefined || loginId === null) {
    } else {
      const result = await this._changeDownloadApi(flag);
      if (result) {
        const intReturn = result.data[0].intReturn;
        //console.log(intReturn)
        if (intReturn === 0) {
          setDownloadBitrate(flag);
          _changeDownload(flag);
          this.setState({
            selected: flag === '1080P' ? true : false,
          });

          const authCookies = this.getCookie('account');

          if (
            authCookies === null ||
            authCookies === undefined ||
            authCookies === ''
          ) {
          } else {
            if (authCookies) {
              const arrAuth = authCookies.split('&');
              //console.log(arrAuth)
              arrAuth.sort();
              //console.log(arrAuth)
              //let cookieData = 'messageCount_output=' + vod + '&birthDay=' + listData[0].birthDay + '&memberPartCode=' + listData[0].download + '&authId=' + authId + '&playerFlag=' + listData[0].playerFlag + '&couponCount=' + listData[0].autoNext + '&jumin=' + listData[0].jumin + '&point=' + listData[0].point + '&sex=' + listData[0].sex + '&loginName=' + listData[0].username + '&loginCode=' + listData[0].loginCode + '&loginId=' + userid

              arrAuth[7] = 'messageCount_output=' + flag;

              let cookieData =
                arrAuth[8] +
                '&' +
                arrAuth[1] +
                '&' +
                arrAuth[7] +
                '&' +
                arrAuth[0] +
                '&' +
                arrAuth[9] +
                '&' +
                arrAuth[2] +
                '&' +
                arrAuth[3] +
                '&' +
                arrAuth[10] +
                '&' +
                arrAuth[11] +
                '&' +
                arrAuth[6] +
                '&' +
                arrAuth[4] +
                '&' +
                arrAuth[5];
              this.setCookie('account', cookieData);
            }
          }
        }
      }
    }
  };
  _changeDownloadApi = (flag) => {
    const { apiUrl, loginId, history } = this.props;
    const { gubun } = this.props.childProps;

    // const at = localStorage.getItem('at');
    const at = this.getCookie('at');
    //console.log(loginId, flag)
    return axios
      .post(
        apiUrl + '/changeDownload',
        {
          params: {
            userid: loginId,
            download: flag,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //console.log('error..')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken(gubun, flag);
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  };
  render() {
    const { name } = this.props.childProps;
    const { selected } = this.state;
    return (
      <Fragment>
        <dl className={selected ? 'active' : null}>
          <dt>{name}</dt>
          <dd>
            <label className="switch">
              <input
                type="checkbox"
                checked={selected}
                onChange={this._onChange}
              />
              <span className="slider"></span>
            </label>
          </dd>
        </dl>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(SettingItem)));
